<div class="main_body">
  <div class="contents contents--user-detail">
    <div class="contents_section_group align-right-button">
      @if (isLoading() || gostRecord) {
        <div class="gost-summary__header">
          <app-details-header
            [title]="headerTitle"
            [badgeText]="headerBadgeText"
            [patientName]="getHeaderPatientName()"
            [measureDate]="getHeaderMeasureDate()"
            [measurer]="getHeaderMeasurer()" />
        </div>
        <div class="gost-digest-slot">
          <gost-digest-card #gost_digest_card [recordData]="gostRecord" [recordDataUpdated]="recordDataUpdated"
            class="gost-summary-digest"
            [loading]="isLoading()"
            [canNavigateOlder]="canNavigateOlder()"
            [canNavigateNewer]="canNavigateNewer()"
            (navigateOlder)="showOlderRecord()"
            (navigateNewer)="showNewerRecord()"
            style="display: contents;"></gost-digest-card>
        </div>
      } @else if (gostRecordLengthZero) {
        <div class="create-new">
          <button mat-flat-button (click)="navigateToNewGostPage()" color="primary"
            class="mat-elevation-z0 align-right-button">
            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
            <span class="full-text" i18n="@@home.gostSummary.button.createNewData">データ手動新規作成</span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
